// extracted by mini-css-extract-plugin
module.exports = {"JSXGraph":"MyPlotterRenderer_JSXGraph__34SWZ"};